import { render, staticRenderFns } from "./Transaction.vue?vue&type=template&id=38900286&scoped=true&"
import script from "./Transaction.vue?vue&type=script&lang=js&"
export * from "./Transaction.vue?vue&type=script&lang=js&"
import style0 from "./Transaction.vue?vue&type=style&index=0&id=38900286&prod&lang=css&"
import style1 from "./Transaction.vue?vue&type=style&index=1&id=38900286&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38900286",
  null
  
)

export default component.exports